export enum GlobalStateKeyEnum {
  AchRefundsReportType = 'AchRefundsReportType',
  App = 'App',
  CancelPendingsReportType = 'CancelPendingsReportType',
  CenterDialog = 'CenterDialog',
  Contact = 'Contact',
  Coverage = 'Coverage',
  CurrentCall = 'CurrentCall',
  DirtyNavigation = 'DirtyNavigation',
  EditDetails = 'EditDetails',
  Error = 'Error',
  FavoriteConsumers = 'FavoriteConsumers',
  FavoriteConsumersHidden = 'FavoriteConsumersHidden',
  FeatureFlag = 'FeatureFlag',
  Impersonation = 'Impersonation',
  MissingDispositions = 'MissingDispositions',
  Payment = 'Payment',
  PaymentForm = 'PaymentForm',
  SidebarDialog = 'SidebarDialog',
  Softphone = 'Softphone',
  SoftphoneInitialized = 'SoftphoneInitialized',
  Toast = 'Toast',
  VerifyDetails = 'VerifyDetails',
  AdjustmentUsageAndModifications = 'AdjustmentUsageAndModifications',
}
